import { render, staticRenderFns } from "./RecommendDialog.vue?vue&type=template&id=3185df24&scoped=true"
import script from "./RecommendDialog.vue?vue&type=script&lang=js"
export * from "./RecommendDialog.vue?vue&type=script&lang=js"
import style0 from "./RecommendDialog.vue?vue&type=style&index=0&id=3185df24&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3185df24",
  null
  
)

export default component.exports